import React from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@deporvillage/utils-library-component';

import styles from './CollapsibleList.module.scss';

const Type = {
    Default: 'default',
    Rift: 'rift',
};

const getTypeClassName = (type) => {
    switch (type) {
        case Type.Rift:
            return styles.rift;    
        default:
            return '';
    }
};

const CollapsibleItem = ({ name, url, type, badge, isAnchor, onClick }) =>
    (isAnchor ? (
        <a
            className={styles['collapsible-item-component']}
            href={url}
            title={name}
            onClick={(e) => e.preventDefault() || onClick(url)}
            data-testid={'collapsible-item'}
        >
            <span className={getTypeClassName(type)}>{name}</span>
            {badge && <span className={styles.badge}>{badge}</span>}
        </a>
    ) : (
        <span
            className={styles['collapsible-item-component']}
            title={name}
            onClick={() => onClick(url)}
            data-testid={'collapsible-item'}
        >
            <span className={getTypeClassName(type)}>{name}</span>
            {badge && <span className={styles.badge}>{badge}</span>}
        </span>
    )
);
CollapsibleItem.propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    isAnchor: PropTypes.bool,
    onClick: PropTypes.func,
};

const CollapsibleList = ({
    id,
    name,
    url,
    badge,
    type,
    items,
    isActive,
    onClick,
    isAnchor = isActive,
    depthLevel = 0,
}) => {
    const { translate } = React.useContext(I18nContext);
    const [isOpen, setIsOpen] = React.useState(isActive);

    const handleClick = (url) => {
        if (url) onClick(url, depthLevel);
        else setIsOpen(!isOpen);
    };

    return (
        <div
            className={`${styles['collapsible-list-component']} ${isOpen ? styles['is-open'] : ''}`}
            data-testid={id && (items ? `toggle-cat-${id}` : `anchor-cat-${id}`)}
        >
            <CollapsibleItem
                {...{ name, url, badge, type, isAnchor: !depthLevel || isAnchor }}
                onClick={(url) => handleClick(items ? null : url)}
            />

            {!items ? null : (
                <ul>
                    {url && (
                        <li data-testid={id && `anchor-cat-${id}`}>
                            <CollapsibleItem
                                name={translate('header.categories.go_to', { category: name })}
                                url={url}
                                onClick={handleClick}
                            />
                        </li>
                    )}

                    {(isActive || isOpen) && items.map((item) => (
                        <li key={item.name}>
                            <CollapsibleList
                                {...{ ...item, onClick, isAnchor, depthLevel: depthLevel + 1 }}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
CollapsibleList.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    url: PropTypes.string,
    active: PropTypes.number,
    isAnchor: PropTypes.bool,
    isActive: PropTypes.bool,
    items: PropTypes.array,
    depthLevel: PropTypes.number,
    type: PropTypes.oneOf([
        Type.Default,
        Type.Rift,
    ]),
    badge: PropTypes.string,
    onClick: PropTypes.func,
};

export default CollapsibleList;
export { Type as CollapsibleListType };
